import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
// HOOKS
import { useAppSelector } from '../../hooks';
// STORE
import { getThemeMode } from '../../store/ConfigSlice';
// CONSTANTS
import { TP_COLORS } from '../../constants';

const CustomGrayBoxIconButton: React.FC<IconButtonProps> = ({
  children,
  sx,
  ...props
}) => {
  // HOOKS
  const themeMode = useAppSelector(getThemeMode);

  // STYLES
  const iconButtonStyles: IconButtonProps['sx'] = {
    backgroundColor:
      themeMode === 'light'
        ? TP_COLORS.paperGray.light
        : TP_COLORS.paperGray.dark,
    borderRadius: '7px',
    '&:focus': {
      backgroundColor:
        themeMode === 'light'
          ? TP_COLORS.paperGray.light
          : TP_COLORS.paperGray.dark,
    },
  };

  // RENDER
  return (
    <IconButton
      {...props}
      sx={
        sx
          ? ({ ...iconButtonStyles, ...sx } as IconButtonProps['sx'])
          : iconButtonStyles
      }
    >
      {children}
    </IconButton>
  );
};

export default CustomGrayBoxIconButton;
